import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import DeleteLocationDialog from "../../molecules/DeleteLocationDialog";
import LocationAlreadyInUseDialog from "../../atoms/LocationAlreadyInUseDialog";
import { useMst } from "../../../hooks/useMst";
import LocationHandler from "../../../services/api/locationHandler";
import Constants from "../../../constants/text-constants";

const DeleteLocation = (props) => {
    const { location, onDeleteClose } = props;
    const { currentUser, locationStore } = useMst();
    const [errorText, setErrorText] = useState("");
    const [loading, setLoading] = useState(false);
    const [locationInUse, setLocationInUse] = useState(false);
    const [locationDescription, setLocationDescription] = useState("");

    const init = useCallback(() => {
        // Get users current registered location
        const locCode = currentUser.agent && currentUser.agent.locationCode
            ? currentUser.agent.locationCode.code
            : null;

        // Need to be careful not to use location after it has been deleted from the store, so
        // make local copies of relevant data.
        setLocationInUse((locCode === location.code));
        setLocationDescription(location.description);
      }, [location, currentUser]);

    useEffect(() => {
        init();
    }, [init]);

    const onDeleteConfirm = () => {
        setErrorText("");
        setLoading(true);

        LocationHandler.deleteLocation(location).then(() => {
            locationStore.deleteLocation(location);

            onDeleteClose();
        }).catch(() => {
            setErrorText(Constants.FAILED_TO_DELETE_LOCATION);
            setLoading(false);
        });
    }

    return (
        locationInUse ?
            (<LocationAlreadyInUseDialog
                locationDescription={locationDescription}
                onConfirm={onDeleteClose}
            />)
            :
            (<DeleteLocationDialog
                locationDescription={locationDescription}
                onCancelDeleteLocation={onDeleteClose}
                onConfirmDelete={onDeleteConfirm}
                loading={loading}
                errorText={errorText}
            />)

    );
}

DeleteLocation.propTypes = {
    location: PropTypes.object,
    onDeleteClose : PropTypes.func,
};

export default DeleteLocation;